import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
    methods: {
        /**
         * Converts UTC date string to local date formatted as YYYY-MM-DD
         * e.g. '2025-06-30T21:00:00.000Z' -> '2025-07-01'
         */
        toLocal (date, format = 'YYYY-MM-DD') {
            if (!date) {
                return null;
            }

            let parsedDate;

            // 1. If it's already a dayjs object, just use it
            if (dayjs.isDayjs(date)) {
                parsedDate = date;
            }
            // 2. Handle string inputs (with or without 'T')
            else if (typeof date === 'string') {
                const trimmed = date.trim();

                // If it ends with 'Z' or contains 'T', treat it strictly as UTC
                if (trimmed.endsWith('Z') || trimmed.includes('T')) {
                    parsedDate = dayjs.utc(trimmed);
                } else {
                    // Standard DB formats (e.g., "2026-06-03 06:38:17") are assumed to be UTC from the server
                    parsedDate = dayjs.utc(trimmed, 'YYYY-MM-DD HH:mm:ss');
                }
            }
            // 3. Fallback for raw Date objects or timestamps
            else {
                parsedDate = dayjs(date);
            }

            // 4. Final safety check: if parsing failed completely, return a safe string instead of breaking the UI
            if (!parsedDate.isValid()) {
                console.warn('Invalid date string passed to toLocal:', date);
                return '---';
            }

            // 5. Shift to Tanzanian local time and apply the format mask
            return parsedDate.tz('Africa/Dar_es_Salaam').format(format);
        },

        /**
         * Converts local YYYY-MM-DD to UTC ISO string
         * e.g. '2025-07-01' -> '2025-06-30T21:00:00.000Z'
         */
        toUtc (date) {
            if (!date) {
                return null;
            }
            return dayjs.tz(date, 'Africa/Dar_es_Salaam').utc().toISOString();
        },

        /**
         * Formats date (any ISO string or object) to display format (default YYYY-MM-DD)
         */
        displayFormat (date, format = 'YYYY-MM-DD') {
            if (!date) {
                return '';
            }
            return dayjs(date).format(format);
        },

        displayLocal (date, format = 'YYYY-MM-DD') {
            if (!date) {
                return '';
            }
            return dayjs(date).format(format);
        },
        // Return now in local time (optionally formatted)
        nowLocal (format = null) {
            const localNow = dayjs();
            return format ? localNow.format(format) : localNow;
        },

        // Return now in UTC (optionally formatted)
        nowUtc (format = null) {
            const utcNow = dayjs().utc();
            return format ? utcNow.format(format) : utcNow;
        },
        disablePastDates(date, minDate = null) {
            // Get our timezone floor
            const localToday = dayjs().tz('Africa/Dar_es_Salaam').startOf('day');

            // If minDate is provided, use it; otherwise use localToday
            const floor = minDate
                ? dayjs.tz(minDate, 'Africa/Dar_es_Salaam').startOf('day')
                : localToday;

            return dayjs(date).isBefore(floor);
        },
        formatLocal: function(d) {
            if (!d) return null;
            var dateObj = new Date(d);
            var year = dateObj.getFullYear();
            var month = String(dateObj.getMonth() + 1).padStart(2, '0');
            var day = String(dateObj.getDate()).padStart(2, '0');
            var hours = String(dateObj.getHours()).padStart(2, '0');
            var minutes = String(dateObj.getMinutes()).padStart(2, '0');
            var seconds = String(dateObj.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
    }
};
